import { useLingui } from "@lingui/react/macro";
import type { ServerError } from "@offstreetparking/design-system/forms";
import { Text } from "@offstreetparking/design-system/typography";
import type { ReactNode } from "react";
import { ResponsiveOverlay } from "../../overlays/ResponsiveOverlay";
import { SendEmailForm } from "./SendEmailForm";

type SendEmailModalProps = {
	onSubmit: (emails: string[]) => void;
	onClose: () => void;
	isOpen: boolean;
	isLoading: boolean;
	serverError?: ServerError;
	description: ReactNode;
	companyId: number;
};

export const SendEmailModal = ({
	onSubmit,
	onClose,
	isOpen,
	isLoading,
	serverError,
	description,
	companyId,
}: SendEmailModalProps) => {
	const { t } = useLingui();

	return (
		<ResponsiveOverlay
			isOpen={isOpen}
			onOpenChange={(open) => {
				if (!open) {
					onClose();
				}
			}}
			title={t`Send email`}
		>
			<Text intent="muted" size="sm" className="mb-4">
				{description}
			</Text>
			<SendEmailForm onSubmit={onSubmit} isLoading={isLoading} serverError={serverError} companyId={companyId} />
		</ResponsiveOverlay>
	);
};
